import React, { useState } from 'react';
import axios from 'axios';
import { CloudArrowUpIcon } from '@heroicons/react/24/outline';

const ImageUploader = ({ onUpload, onReset }) => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!image) return;

    setUploading(true);
    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'lazerzone');

    try {
      const res = await axios.post(
        'https://api.cloudinary.com/v1_1/dnzpehgui/image/upload',
        formData
      );
      const imageUrl = res.data.secure_url;
      onUpload(imageUrl);
    } catch (err) {
      console.error('Error al subir imagen:', err);
    } finally {
      setUploading(false);
    }
  };

  const handleReset = () => {
    setImage(null);
    setPreview(null);
    onReset?.();
  };

  return (
    <div className="w-full bg-[#1F2937] p-4 rounded-xl border border-[#566D87]">
      <div className="flex flex-col sm:flex-row items-center gap-4">
        <div className="w-full sm:w-1/3">
          <label className="block mb-2 text-sm text-[#E9EAE8]/80">Seleccionar imagen</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="w-full text-sm text-white bg-[#141318] border border-[#566D87] rounded px-2 py-1"
          />
        </div>

        {preview && (
          <div className="w-full sm:w-1/3">
            <p className="mb-2 text-sm text-[#E9EAE8]/70">Vista previa:</p>
            <img
              src={preview}
              alt="Preview"
              className="aspect-video object-cover rounded border border-[#566D87]"
            />
          </div>
        )}

        <div className="w-full sm:w-1/3 flex flex-col items-center justify-center gap-2 mt-4 sm:mt-0">
          <button
            onClick={handleUpload}
            disabled={uploading}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded transition"
          >
            <CloudArrowUpIcon className="w-5 h-5" />
            {uploading ? 'Subiendo...' : 'Subir imagen'}
          </button>

          {preview && (
            <button
              onClick={handleReset}
              className="text-red-400 text-sm hover:underline"
            >
              Quitar imagen seleccionada
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageUploader;
